export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.21.1';
//# sourceMappingURL=version.js.map